import { Controller } from "@hotwired/stimulus"

// A conversation header's phone: starts a hands-free call about this thread.
// The same window event every call raises (jane_sidebar#call, the + menu's
// assistant_compose#startCall, the avatar's call) — one call bar answers it
// for the whole app (shared/_jane_call_dock), so there is only ever one call.
// The composer's mic never calls: it records a voice message.
export default class extends Controller {
    static values = { conversationId: String }

    start(event) {
        event?.preventDefault()
        const conversationId = this.conversationIdValue || null
        window.dispatchEvent(new CustomEvent("assistant-voice:open", { detail: { conversationId } }))
    }
}
